import { actions, selectors } from 'data'
import React from 'react'
import Measure from 'react-measure'
import { connect } from 'react-redux'
import styled from 'styled-components'

const Sensor = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`
// Observes and reports screen size
const ScreenObserver = ({ setScreenSize }) => (
  <Measure
    bounds
    onResize={(contentRect: { bounds: ClientRect }) => {
      setScreenSize(contentRect.bounds)
    }}
  >
    {({ measureRef }) => <Sensor ref={measureRef} />}
  </Measure>
)

const mapStateToProps = (state) => ({
  screenWidth: selectors.app.getScreenWidth(state)
})

const mapDispatchToProps = (dispatch) => ({
  setScreenSize: (rect) => {
    dispatch(actions.app.setScreenSize(rect))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ScreenObserver)
